/**
 * URL del formulario de la encuesta (popup flotante "Encuesta 2026").
 * Cadena vacía: el componente no se muestra.
 */
export const SURVEY_POPUP_URL = 'https://forms.gle/Gh6CNGUrEHaCBzkU8'
